<div fxLayout="row" fxLayoutAlign="start center">
  <div
    class="workflow-step-color"
    [ngStyle]="{ 'background-color': htmlColorCode }"
  ></div>
  <div class="step-label">{{ label }}</div>
</div>
